import { createApp, provide, computed } from 'vue'
import { createHead } from '@unhead/vue'
// import { VueFbq } from 'vue3-facebook-pixel'
import './style.scss'
import App from './App.vue'
// [PERF 2026-10-14] antd 改按需引入（unplugin-vue-components），不再全量引入
import VueLazyLoad from 'vue3-lazyload'
import { setupPinia } from './store'
import myModal from '@/components/common/modal/index.vue'
import empty from '@/components/common/empty/index.vue'
import customMessage from '@/lib/custom/scrollTipBar.js'
import showNotice from '@/components/common/notice/notice.js'
// import { loginModal } from "@/components/common/login/fnlogin.js";
import { loginModal } from "@/components/common/login";
// 标准的ES模块化引入方式
import mitt from 'mitt'
import MySocket from "@/request/socket.js"
import autoAuth from '@/utils/autoAuth.js'
// import VueLuckyCanvas from "@lucky-canvas/vue";
import backbar from "@/components/common/backbar/backbar.vue";
import eventEmitter from "@/utils/emitter.js";

// i18n
import i18n, { detectBrowserLang } from './i18n'
const { t: $t, locale } = i18n.global;
// import store from "@/store/index.js"
import router from './router'
import { getImageUrlByNewURL } from '@/utils/getImageUrl.js';
import dimg from '@/utils/dynamicImgHandle.js'
import dname from '@/utils/dynamicAwardName.js'
import delST from '@/utils/delST.js'
import scroll from '@/utils/noscroll.js';
import $api from "@/api"
import { dynamicAwardColor, awardBgi, awardBgiResult } from '@/utils/awardQuality.js'
import DesignationInstruction from '@/utils/debounce.js';
import copyToClipboard from "@/utils/copyContent.js";
import { initFbPixel } from '@/utils/useFbPixel.js';
import { initConsent } from '@/utils/consent.js';
// console.log('dy;',dynamicAwardColor);
const app = createApp(App);
const head = createHead();
app.use(VueLazyLoad, {
  log: true,
  lifecycle: {
    loading: () => {
      console.log('loading')
    },
    error: () => {
      console.log('error')
    },
    loaded: () => {
      console.log('loaded')
    },
  },
})
// console.log('api:', import.meta.env.VITE_API_BASE_URL, import.meta.env.VITE_LANG);

// Google 标签初始化
import { createGtag } from 'vue-gtag'
import { query } from 'vue-gtag'
import { pageview } from 'vue-gtag'
// 2026-10-26 EU 同意：先全部 denied，用户选择后再 update
if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('consent', 'default', {
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        analytics_storage: 'denied'
    });
}
const gtag = createGtag({
    tagId: import.meta.env.VITE_GA_MEASUREMENT_ID,
    // additionalAccounts:[
    //     { tagId: 'GA_MEASUREMENT_ID_2' },
    // ]
})
app.use(gtag)
query("get", import.meta.env.VITE_GA_MEASUREMENT_ID,"client_id", (clientID) => {
  console.log("GA4 client_id:", clientID);
  localStorage.setItem('ga4_client_id', clientID);
  if(window.location.hostname.includes("fateskins.net")){
      localStorage.setItem('ga4_client_id', '');
  }
  autoAuth();
})
DesignationInstruction(app)//给应用注册防抖指令
app.component('backbar', backbar)
//provide
app.provide('$getImageUrlByNewURL', getImageUrlByNewURL)
app.provide('scroll', scroll)

//globalProperties
app.config.globalProperties.$getImageUrlByNewURL = getImageUrlByNewURL
app.config.globalProperties.$dimg = dimg
app.config.globalProperties.$dname = dname
app.config.globalProperties.$delST = delST
app.config.globalProperties.$dynamicAwardColor = dynamicAwardColor.value//导入计算属性,js中要加.value
app.config.globalProperties.$dynamicAwardBgImg = awardBgi.value
app.config.globalProperties.$dynamicAwardBgImgResult = awardBgiResult.value
app.config.globalProperties.$cmessage = customMessage;
app.config.globalProperties.$eventEmitter = eventEmitter;
// app.config.globalProperties.$notice = showNotice;

// app.use(store)
setupPinia(app);
app.use(head)
// app.use(VueFbq, { pixelId: '1360166878355946', debug: true })//facebook-pixel-id
app.use(i18n)
app.use(router)
// app.use(Antd) 已移除：改为按需自动导入
app.component('myModal', myModal)
app.component('empty', empty)
app.use(MySocket) //连接websocket
// app.use(VueLuckyCanvas)
app.config.globalProperties.$notice = showNotice;
app.config.globalProperties.$copyToClipboard = copyToClipboard;
app.config.globalProperties.$EventBus = new mitt()
app.mount('#app');

// 2026-10-26 EU 同意横幅：非 EU 直接放行；EU 先弹，选择后再初始化 Pixel / 更新 GA4
initConsent(function (choice) {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('consent', 'update', {
            ad_storage: choice.ads ? 'granted' : 'denied',
            ad_user_data: choice.ads ? 'granted' : 'denied',
            ad_personalization: choice.ads ? 'granted' : 'denied',
            analytics_storage: choice.analytics ? 'granted' : 'denied'
        });
    }
    if (choice.ads) {
        initFbPixel({
            pixelId: import.meta.env.VITE_META_PIXEL_ID,
            debug: false
        });
    }
});

router.beforeEach(async (to, from, next) => {
  console.log('mainto:', to, 'from:', from, 'next:', next);
  console.log('to.params:', to.params);
  console.log('tomatched;', to.matched);

  if (to.name == "sandbox") {
    localStorage.setItem('sandbox', true);
  }

  if (to.name == "steamCallback") {
    console.log('steamCallback');
  }
  //根据地址栏修改的语言包,更新页面语言包跟语言旗帜
  if (to.params.lang) {
    console.log('🔍 [router] to.params.lang:', to.params.lang, '| localStorage lang:', localStorage.getItem('lang'))
    if ('unn' === to.params.lang) {
      // 未设置语言(首次访问)，三级检测链：
      // ① 后端接口GET /getLang(IP判断) → ② 浏览器语言(navigator.languages) → ③ 兜底en
      let resolvedLang = null;

      // ① 优先：后端接口按IP判断（中国IP→中文，海外IP→对应语言）
      try {
        const res = await $api.user.getLang();
        console.log('🔍 [router] 后端getLang返回:', res);
        if (res.code === 200 && res.data) {
          resolvedLang = res.data;
          console.log('🌐 后端IP语言检测命中:', resolvedLang);
        }
      } catch (e) {
        console.warn('🔍 [router] 后端getLang接口异常:', e);
      }

      // ② 后端失败时：浏览器语言检测
      if (!resolvedLang) {
        try {
          resolvedLang = detectBrowserLang();
          if (resolvedLang) {
            console.log('🌐 浏览器语言检测命中:', resolvedLang);
          }
        } catch (e) {
          console.warn('🔍 [router] 浏览器语言检测异常:', e);
        }
      }

      // ③ 兜底：en
      if (!resolvedLang) {
        resolvedLang = 'en';
        console.log('🌐 所有检测均未命中，兜底en');
      }

      eventEmitter.emit('update:lang', resolvedLang);
      next({
        name: to.name,
        params: {
          lang: resolvedLang
        }
      })
    } else {
      eventEmitter.emit('update:lang', to.params.lang)
    }
  }

  if (to.name == "battle" && from.name != "battleRoom") {
    // console.log('不保留对战key状态,清除对战tabkey状态');
    eventEmitter.emit("reset:battleTabKey");
  }
  // if(to.name=="battle"&&from.name=="battleRoom"){
  //   console.log('从对战房间详情返回到对战大厅');

  // }else{
  //   //重置对战tabkey=1
  //   eventEmitter.emit("reset:battleTabKey");
  // }

  const token = localStorage.getItem('token')
  // autoAuth()
  // console.log('tto ;',to);
  if (to.path.includes('/api/steam/handle')) {
    const response = await fetch(to.fullPath);
    // console.log('resp;', response);
    next('box')
  }
  if (to.meta.needLogin) {
    // console.log("访问需要权限",token)
    if (token) {
      next()
    } else {
      // console.log('需要登录')
      eventEmitter.emit("api:un_auth");
      // loginModal({ visible: true }, (callnack) => {
      //   // console.log('未登录 弹登录框');
      //   callnack();
      // });

      // loginModal(
      //   { visible: true, title: $t('loginLarge'), contentType: "def" },
      //   (callnack) => {
      //     // console.log('未登录 弹登录框');
      //     callnack();
      //   }
      // );
      next({
        path: from.path || '/'
      })
    }
  } else {
    next()
  }
})
router.afterEach((to, from, next) => {
    console.log('afterEach:', to);
    pageview({
        page_title: to.name,
        page_path: to.path
    })
    // document.querySelector(".main-wrapper").scrollTop = 0;
    // window.scrollTo(0,0)
});

//改变font-size
(function (doc, win) {
  var docEI = doc.documentElement,
    resizeEvt = 'orientationchange' in window ? 'orientataionchange' : 'resize',
    recalc = function () {
      var clientWidth = docEI.clientWidth;
      if (!clientWidth) return;
      //100是字体大小，1536是开发时浏览器窗口的宽度，等比计算
      docEI.style.fontSize = 100 * (clientWidth / 1920) + 'px';
      // console.log('绑定监听事件，dom加载后和尺寸变化时改变font-size',docEI.style.fontSize);
    }

  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window);
